<template>
  <div class="map">
    <h3>Vehicle : {{ vehicle_plate }}</h3>
    <div id="map"></div>
  </div>
</template>

<script>
  import { getVehicleByID } from "network/vehicle";

  export default {
    name: "Map",
    data() {
      return {
        vehicle_plate: "",
        vehicle_id: "",
        gateway: "",
        lat: 0,
        lng: 0
      }
    },
    created() {
      this.vehicle_plate = this.$route.query.plate
      this.vehicle_id = this.$route.query.vehicle_id
    },
    mounted() {
      this.getVehicleDetail(this.vehicle_id)
      
      
    },
    methods: {
      getVehicleDetail(id) {
        getVehicleByID(id)
          .then((data) => {
            const rawData = data.data
            this.gateway = rawData.gateway.gateway_id
            this.lat = rawData.gateway.lat
            this.lng = rawData.gateway.lng

            this.initMap()
            
          })
          .catch((err) => {
            this.$message.error("Interface error: get_vehicle_detail");
          });
      },
      initMap() {
        const mapProp = {
          center: { 
            lat: Math.abs(this.lat) > 0 ? this.lat : 9.512247, 
            lng: Math.abs(this.lng) > 0 ? this.lng : -13.710318
          },
          zoom: 14,
          disableDefaultUI: true,
          mapId: "a3c5a60ff715a444",
          mapTypeId: window.google.maps.MapTypeId.HYBRID,
        }
        
        const map = new window.google.maps.Map(document.getElementById('map'), mapProp);

        const marker = new window.google.maps.Marker({
          position: { lat: this.lat, lng: this.lng },
          map: map
        })
      }
    }
  }
</script>

<style scoped>
.map h3 {
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: 400;
  color: #1f2f3d;
}
#map{
  width: 100%;
  height:calc(100vh - 205px) ;
}
</style>
